import axios from 'axios';
import config from '../config';

const cwtSigning = async (cborHex: string): Promise<string> => {
  try {
    const formData = new FormData();
    const blob = new Blob([cborHex], { type: 'application/octet-stream' });
    formData.append('file', blob, 'cbor-data.cbor');

    const response = await axios.post(`${config.baseURL}/cwtSign`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data; // Assuming the API returns the signed CWT data as a string
  } catch (error) {
    console.error('Error signing CWT:', error);
    throw new Error('Failed to sign CWT');
  }
};

export default cwtSigning;